// src/footerConfigs.js

export const footerConfigs = {
  "bheema": {
    brandName: "Shri Pavada Basaveshwar School",
    contact: "+91 8105127211,7619137937 | basaveshwarskl@gmail.com",
    socialLinks: {
      instagram: "https://www.instagram.com/",
      whatsapp:   "https://wa.me/yourwhatsapplink",
      youtube:    "https://www.youtube.com/",
      facebook:   "https://www.facebook.com/",
      twitter:    "https://twitter.com"
    }
  },

  "acmeCorp": {
    brandName: "ACME Corporation",
    contact: "1800-ACME | support@acme.com",
    socialLinks: {
      instagram: "https://instagram.com/acmecorp",
      whatsapp:   "",
      youtube:    "https://youtube.com/acmecorp",
      facebook:   "https://facebook.com/acmecorp",
      twitter:    "https://twitter.com/acmecorp"
    }
  }

  // add more customer configs here...
};
